import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "progress"]

  connect() {
    this.inputTarget.addEventListener('direct-upload:initialize', this.initializeUpload)
    this.inputTarget.addEventListener('direct-upload:start', this.startUpload)
    this.inputTarget.addEventListener('direct-upload:progress', this.progressUpload)
    this.inputTarget.addEventListener('direct-upload:error', this.errorUpload)
    this.inputTarget.addEventListener('direct-upload:end', this.endUpload)
  }

  initializeUpload(event) {
    const { target, detail } = event
    const { id, file } = detail
    target.insertAdjacentHTML('beforebegin', `
      <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
        <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
        <span class="direct-upload__filename">${file.name}</span>
      </div>
    `)
  }

  startUpload(event) {
    const { id } = event.detail
    const element = document.getElementById(`direct-upload-${id}`)
    element.classList.remove("direct-upload--pending")
    element.classList.add("direct-upload--current")
  }

  progressUpload(event) {
    const { id, progress } = event.detail
    const progressElement = document.getElementById(`direct-upload-progress-${id}`)
    progressElement.style.width = `${progress}%`
  }

  errorUpload(event) {
    event.preventDefault()
    const { id, error } = event.detail
    const element = document.getElementById(`direct-upload-${id}`)
    element.classList.add("direct-upload--error")
    element.setAttribute("title", error)
  }

  endUpload(event) {
    const { id } = event.detail
    const element = document.getElementById(`direct-upload-${id}`)
    element.classList.add("direct-upload--complete")
  }
}